import { TableAdapter } from '@makyoapp/makyo-common'

import { TablesDropdownV2 } from '../TablesDropdownV2'

export function VariableTable({
  id,
  tbl,
  setTbl,
  tblOptions,
  portalMenu = true,
  disabled = false,
}: {
  id?: string
  tbl?: string
  setTbl: (next: string) => void
  tblOptions: TableAdapter[]
  portalMenu?: boolean
  disabled?: boolean
}) {
  return (
    <div className='px-2 w-full'>
      <TablesDropdownV2 value={tbl} onChange={setTbl} tables={tblOptions} showPlaceholder />
    </div>
  )
}
